export interface FormatOption {
  id: number
  title: string
  desc: string
  isPremium?: boolean
  analyticSrc?: string
}

export enum QUALITY_OPTION {
  LOW = 'LOW',
  HIGH = 'HIGH',
}

export const QUALITY_MULTIPLIERS: Record<QUALITY_OPTION, number> = {
  [QUALITY_OPTION.LOW]: 0.9,
  [QUALITY_OPTION.HIGH]: 1,
}

export interface QualityOption {
  label: string
  value: QUALITY_OPTION
  isPremium?: boolean
}

export const QUALITY_OPTIONS: QualityOption[] = [
  { label: 'Low', value: QUALITY_OPTION.LOW },
  { label: 'High', value: QUALITY_OPTION.HIGH, isPremium: true },
]

export const FORMAT_OPTIONS: Record<string, FormatOption> = {
  jpeg: {
    id: 1,
    title: 'jpeg',
    desc: 'No transparency. High quality. Files are generally small.',
  },
  png: {
    id: 2,
    title: 'png',
    desc: 'Supports transparency. Best quality. Files can be big.',
  },
  webp: {
    id: 3,
    title: 'webp',
    desc: 'Supports transparency. Supreme quality. Files are smallest.',
    isPremium: true,
    analyticSrc: 'BtSubscriptionWebP',
  },
  pdf: {
    id: 4,
    title: 'pdf',
    desc: 'Best for documents.',
    isPremium: true,
    analyticSrc: 'BtSubscriptionPDF',
  },
}

/** Default format when no transparent background is detected */
export const DEFAULT_FORMAT_KEY = 'jpeg'

/** Format key to use when a transparent background is detected */
export const TRANSPARENT_BG_FORMAT_KEY = 'png'

export const VIDEO_FORMAT_OPTIONS: Record<string, FormatOption> = {
  mp4: {
    id: 1,
    title: 'mp4',
    desc: 'Supports motion. High compatibility. Files are generally small.',
  },
}
